import React from "react";
import PropTypes from "prop-types";

import CaretIcon from "views/components/icons/CaretIcon";

import { noop } from "lib";

import style from "./style.module.css";

const ExpandableBox = ({ children, isExpanded, onClick, isActive = true }) => {
  return (
    <div className={style.wrapper}>
      <div
        className={`${style.header}${!isActive ? ` ${style.inactive}` : ""}`}
        onClick={isActive ? onClick : noop}
      >
        <div className={style.headerContent}>{children[0]}</div>
        {isActive && (
          <div className={style.toggle}>
            <CaretIcon direction={isExpanded ? "down" : "right"} />
          </div>
        )}
      </div>
      {isExpanded && <div className={style.content}>{children[1]}</div>}
    </div>
  );
};

ExpandableBox.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ExpandableBox;
